class VideoBounce {
  constructor(video) {
    this.video = video;
    this.isReversing = false;
    this.init();
  }

  init() {
    // The `loop` attribute suppresses the `ended` event, so it must be removed
    // for the bounce to take over; without JS the native loop stays as fallback.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.video.removeAttribute('loop');
    this.video.loop = false;

    // Ensure video metadata is loaded before setting up
    if (this.video.readyState >= 2) {
      this.setupEvents();
    } else {
      this.video.addEventListener('loadedmetadata', () => this.setupEvents(), { once: true });
    }
  }

  setupEvents() {
    this.video.addEventListener('ended', () => this.playBackwards());
  }

  playBackwards() {
    if (this.isReversing) return;

    this.isReversing = true;
    this.video.pause();

    const targetFPS = 30;
    const frameTime = 1000 / targetFPS;
    const timeStep = 1 / targetFPS;
    let lastFrameTime = performance.now();

    const reverse = (currentTime) => {
      const elapsed = currentTime - lastFrameTime;

      if (elapsed >= frameTime) {
        if (this.video.currentTime <= 0.1) {
          this.video.currentTime = 0;
          this.isReversing = false;
          this.video.play();
          return;
        }

        this.video.currentTime = Math.max(0, this.video.currentTime - timeStep);
        lastFrameTime = currentTime - (elapsed % frameTime);
      }

      if (this.isReversing) {
        requestAnimationFrame(reverse);
      }
    };

    requestAnimationFrame(reverse);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-bounce').forEach(video => {
    new VideoBounce(video);
  });
});
